import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { RootState } from '../store';
import { ApplicationTaskType } from '@entities/application/IApplicationTask';

export enum ApplicationAction {
  Create = 'create',
  Edit = 'edit',
}

export interface IApplicationState {
  algorithm: ApplicationAction | null;
  cashback: ApplicationAction | null;
  conditions: ApplicationAction | null;
  connection: ApplicationAction | null;
  mining: ApplicationAction | null;
  id: string | null;
}

const initialState: IApplicationState = {
  algorithm: null,
  cashback: null,
  conditions: null,
  connection: null,
  mining: null,
  id: null,
};

interface IApplicationTask {
  type: ApplicationTaskType;
  id: number;
}

export const applicationSlice = createSlice({
  initialState,
  name: 'applicationSlice',
  reducers: {
    showAlgorithmCreate: (state: any, action: PayloadAction) => {
      state.algorithm = ApplicationAction.Create;
    },
    showAlgorithmEdit: (state: any, action: PayloadAction<IApplicationTask>) => {
      state.algorithm = ApplicationAction.Edit;
      state.id = action.payload.id;
    },
    showCashBackCreate: (state: any, action: PayloadAction) => {
      state.cashback = ApplicationAction.Create;
    },
    showCashBackEdit: (state: any, action: PayloadAction<IApplicationTask>) => {
      state.cashback = ApplicationAction.Edit;
      state.id = action.payload.id;
    },
    showConditionsCreate: (state: any, action: PayloadAction) => {
      state.conditions = ApplicationAction.Create;
    },
    showConditionsEdit: (state: any, action: PayloadAction<IApplicationTask>) => {
      state.conditions = ApplicationAction.Edit;
      state.id = action.payload.id;
    },
    showConnectionCreate: (state: any, action: PayloadAction) => {
      state.connection = ApplicationAction.Create;
    },
    showConnectionEdit: (state: any, action: PayloadAction<IApplicationTask>) => {
      state.connection = ApplicationAction.Edit;
      state.id = action.payload.id;
    },
    showMiningCreate: (state: any, action: PayloadAction) => {
      state.mining = ApplicationAction.Create;
    },
    showMiningEdit: (state: any, action: PayloadAction<IApplicationTask>) => {
      state.mining = ApplicationAction.Edit;
      state.id = action.payload.id;
    },
    closeApplicationManipulators: (state: any, action: PayloadAction) => {
      state.algorithm = null;
      state.cashback = null;
      state.conditions = null;
      state.connection = null;
      state.mining = null;
    },
  },
});

export default applicationSlice.reducer;

export const selectAlgorithm = (state: RootState) => state.application.algorithm;
export const selectCashback = (state: RootState) => state.application.cashback;
export const selectChanging = (state: RootState) => state.application.conditions;
export const selectConnection = (state: RootState) => state.application.connection;
export const selectMining = (state: RootState) => state.application.mining;
export const selectApplicationId = (state: RootState) => state.application.id;

export const {
  showAlgorithmCreate,
  showAlgorithmEdit,
  showCashBackCreate,
  showCashBackEdit,
  showConditionsCreate,
  showConditionsEdit,
  showConnectionCreate,
  showConnectionEdit,
  showMiningCreate,
  showMiningEdit,
  closeApplicationManipulators,
} = applicationSlice.actions;
